import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography } from '@mui/material';
import { FiberManualRecord, FullscreenExitRounded, FullscreenRounded, Print, } from '@mui/icons-material';
import { useContext, useMemo, useRef } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { DeviceIoList } from 'z3k-settings/components/service/components/device-io-model/ui/device-io-list';
import { getUsedIOList } from 'z3k-settings/components/service/components/device-io-model/model/get-used-io-list';
import { useFullscreen } from 'shared/components/widgets/interactive-board/lib/full-screen';
import { useReactToPrint } from 'react-to-print';
import { useIsFullscreen } from 'shared/map/ui/components/control-buttons/components/fullscreen/lib';
import { ErrorBoundary } from 'console/shared/components/error-boundary';
import { PortRS485 } from 'z3k-config';
import { DeviceModel } from 'z3k-settings/components/service/components/device-io-model/ui/device-model';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { DeviceIconView, hasIconForModel, } from 'z3k-settings/components/service/components/device-io-model/ui/device-icon';
import { DeviceModel as TypeDeviceModel } from '../model/device-model-type';
const device_names_for_hidden_list = [TypeDeviceModel.Socket03];
export function useOutputsIcon(io_ext_ids, device_name) {
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec, hardware_type } = useContext(Z3KSettings);
    const used_io_list = getUsedIOList(config, device_spec, io_ext_ids);
    const [fullscreen_ref, onClickFullScreen] = useFullscreen();
    const is_fullscreen = useIsFullscreen();
    const printRef = useRef(null);
    const buttonRef = useRef(null);
    const _onClickPrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: `Печать ${device_name}`,
        onBeforeGetContent: () => {
            if (buttonRef.current) {
                buttonRef.current.style.display = 'none';
            }
        },
        onAfterPrint: () => {
            if (buttonRef.current) {
                buttonRef.current.style.display = 'flex';
            }
        },
        removeAfterPrint: true,
    });
    const has_icon = useMemo(() => hasIconForModel(device_name), [device_name]);
    const show_list = useMemo(() => device_name == null
        ? false
        : !device_names_for_hidden_list.includes(device_name), [device_name]);
    if (!has_icon) {
        return null;
    }
    return (_jsx(ErrorBoundary, { children: _jsxs(Box, { ref: printRef, sx: {
                '@page': {
                    size: 'Letter portrait',
                },
            }, position: "relative", width: "100%", children: [_jsxs(Box, { ref: fullscreen_ref, display: "flex", flexDirection: "column", width: "100%", children: [show_list && (_jsxs(Box, { display: "flex", justifyContent: "flex-end", ref: buttonRef, children: [_jsxs(Box, { display: "flex", flexDirection: isSmallUI() ? 'column' : undefined, alignItems: isSmallUI() ? 'flex-start' : 'center', flexGrow: 1, gap: 1, children: [_jsxs(Box, { display: "flex", children: [_jsx(FiberManualRecord, { sx: { color: 'warning.main' } }), _jsx(Typography, { color: "textSecondary", children: "\u2014\u00A0\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043E" })] }), _jsxs(Box, { display: "flex", children: [_jsx(FiberManualRecord, { sx: { color: '#d0d0ce' } }), _jsx(Typography, { color: "textSecondary", children: "\u2014\u00A0\u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E" })] }), _jsxs(Box, { display: "flex", children: [_jsx(FiberManualRecord, { sx: { color: 'error.main' } }), _jsx(Typography, { color: "textSecondary", children: "\u2014\u00A0\u043F\u043E\u0434 Modbus" })] })] }), _jsx(IconButton, { onClick: onClickFullScreen, children: is_fullscreen ? (_jsx(FullscreenExitRounded, {})) : (_jsx(FullscreenRounded, {})) }), _jsx(IconButton, { onClick: _onClickPrint, children: _jsx(Print, {}) })] })), _jsx(DeviceIconView, { children: _jsx(Box, { position: "relative", children: _jsx(DeviceModel, { model: device_name, used_io_list: used_io_list, hardware: parseInt(hardware_type, 10), isActiveModbus: config.port_rs485?.setting_register ===
                                        PortRS485.Type.modbus }) }) })] }), show_list && _jsx(DeviceIoList, { used_io_list: used_io_list })] }) }));
}
